import React from "react";
import PropTypes from "prop-types";

export const InvestmentAllocationStep = props => {
  let updatedData = props.data;
  let arr = [];
  for (const pool in updatedData.portfolioBuildersForm) {
    if (Object.prototype.hasOwnProperty.call(updatedData.portfolioBuildersForm, pool)) {
      if(updatedData.portfolioBuildersForm[pool]["Percentage"] > 0 )
      arr.push({ [pool]: updatedData.portfolioBuildersForm[pool] });
    }
  }
  for (const pool in updatedData.portfolioSolutionsForm) {
      if (Object.prototype.hasOwnProperty.call(updatedData.portfolioSolutionsForm, pool)) {
        if(updatedData.portfolioSolutionsForm[pool]["Percentage"] > 0 )
        arr.push({ [pool]: updatedData.portfolioSolutionsForm[pool] });
      }
  }
  for (const pool in updatedData.valueDrivenForm) {
      if (Object.prototype.hasOwnProperty.call(updatedData.valueDrivenForm, pool)) {
        if(updatedData.valueDrivenForm[pool]["Percentage"] > 0 )
        arr.push({ [pool]: updatedData.valueDrivenForm[pool] });
      }
  }
  return (
         <div data-test="wrapper">
           <div>Allocation : {props.preference === 'customPercentage' ? 'Custom Percentage' : 'Weighted Percentage'}</div>
           <div>No. of Pools selected : {arr.length} </div>
          </div>
       
  );
};

InvestmentAllocationStep.propTypes = {
  updatedData: PropTypes.object
}